/**
 * 디자인가이드에 Icon으로 정리된 항목입니다. ic_ 로 시작하는 파일들의 모음입니다.
 * Image와 근본은 다를 게 없기에 결국 Static Image 로 렌더링되지만, active와 disabled 상태가 별도로 정의되어 있습니다.
 * https://www.figma.com/file/lun1D9CzpkoufkINaOHID1/NEXT_Design_System?node-id=3330%3A23223
 */
export enum IconType {
  TitleBarArrowRight = 'TitleBarArrowRight',
  ButtonCloseSolidSStatic = 'ButtonCloseSolidSStatic',
  ButtonCloseSolidMPcStatic = 'ButtonCloseSolidMPcStatic',
  ButtonCashFriendsStatic = 'ButtonCashFriendsStatic',
  ButtonKakaoLogoStatic = 'ButtonKakaoLogoStatic',
  ButtonCloseMStatic = 'ButtonCloseMStatic',
  ButtonCloseSolidS = 'ButtonCloseSolidS',
  ButtonArrowS = 'ButtonArrowS',
  ButtonArrowLeft = 'ButtonArrowLeft',
  ButtonArrowRight = 'ButtonArrowRight',
  ButtonArrowUp = 'ButtonArrowUp',
  ButtonArrowDown = 'ButtonArrowDown',
  ButtonArrowRightYellowStatic = 'ButtonArrowRightYellowStatic',
  ButtonCloseS = 'ButtonCloseS',
  ButtonPlusM = 'ButtonPlusM',
  ButtonMinus = 'ButtonMinus',
  ButtonMoreStatic = 'ButtonMoreStatic',
  ButtonMoreArrowStatic = 'ButtonMoreArrowStatic',
  ButtonPlusL = 'ButtonPlusL',
  ButtonShare = 'ButtonShare',
  ButtonArrowLeftMStatic = 'ButtonArrowLeftMStatic',
  ButtonArrowRightMStatic = 'ButtonArrowRightMStatic',
  ButtonArrowLeftLStatic = 'ButtonArrowLeftLStatic',
  ButtonArrowRightLStatic = 'ButtonArrowRightLStatic',
  ButtonNotice = 'ButtonNotice',
  ButtonHelpS = 'ButtonHelpS',
  ButtonHelpS2 = 'ButtonHelpS2',
  ButtonHelpM = 'ButtonHelpM',
  ListHeartOnStatic = 'ListHeartOnStatic',
  ListHeartOn = 'ListHeartOn',
  ListCommentOnStatic = 'ListCommentOnStatic',
  ListCommentOn = 'ListCommentOn',
  ListBookmarkOnStatic = 'ListBookmarkOnStatic',
  ListHeartOff = 'ListHeartOff',
  ListCommentOff = 'ListCommentOff',
  ListBookmarkOff = 'ListBookmarkOff',
  ListClose = 'ListClose',
  ListMore = 'ListMore',
  ListReply = 'ListReply',
  ListCommentCloseMw = 'ListCommentCloseMw',
  ListCommentClose02Mw = 'ListCommentClose02Mw',
  ListMetadataDot = 'ListMetadataDot',
  ListMetadataDotStatic = 'ListMetadataDotStatic',
  CheckBoxSOnStatic = 'CheckBoxSOnStatic',
  CheckBoxMOnStatic = 'CheckBoxMOnStatic',
  CheckBoxLOnStatic = 'CheckBoxLOnStatic',
  CheckBoxSOff = 'CheckBoxSOff',
  CheckBoxMOff = 'CheckBoxMOff',
  CheckBoxLOff = 'CheckBoxLOff',
  CheckOn = 'CheckOn',
  CheckOff = 'CheckOff',
  RadioOff = 'RadioOff',
  RadioOffV2 = 'RadioOffV2',
  RadioOnStatic = 'RadioOnStatic',
  RadioOnV2 = 'RadioOnV2',
  PlayerPlayStatic = 'PlayerPlayStatic',
  PlayerSoundStatic = 'PlayerSoundStatic',
  PlayerMuteStatic = 'PlayerMuteStatic',
  PlayerPlaySolidStatic = 'PlayerPlaySolidStatic',
  PlayerPlaySolidLStatic = 'PlayerPlaySolidLStatic',
  EditSolidStatic = 'EditSolidStatic',
  PopupCheck = 'PopupCheck',
  ModalCheck = 'ModalCheck',
  ModalCheckStatic = 'ModalCheckS',
  ModalKakaoLogo = 'ModalKakaoLogo',
  ModalFacebookLogo = 'ModalFacebookLogo',
  ModalLink = 'ModalLink',
  ModalTwitterLogo = 'ModalTwitterLogo',
  TopSolid = 'TopSolid',
  RankingArrowDownStatic = 'RankingArrowDownStatic',
  RankingArrowUpStatic = 'RankingArrowUpStatic',
  RankingNewStatic = 'RankingNewStatic',
  RankingStayStatic = 'RankingStayStatic',
  SearchArrowDownStatic = 'SearchArrowDownStatic',
  SearchArrowUpStatic = 'SearchArrowUpStatic',
  SearchStayStatic = 'SearchStayStatic',
  Search = 'Search',
  SearchList = 'SearchList',
  SearchListButton = 'SearchListButton',
  SearchButton = 'SearchButton',
  ContentHomeBook = 'ContentHomeBook',
  ContentHomeNovel = 'ContentHomeNovel',
  ContentHomeChat = 'ContentHomeChat',
  ContentHomeComic = 'ContentHomeComic',
  ContentHomeHelpSolidStatic = 'ContentHomeHelpSolidStatic',
  ContentHomeNoticeSolidStatic = 'ContentHomeNoticeSolidStatic',
  PcContentHomeNoticeSolidStatic = 'PcContentHomeNoticeSolidStatic',
  ContentHomeView = 'ContentHomeView',
  ContentHomeStar = 'ContentHomeStar',
  ContentHomeStarPc = 'ContentHomeStarPc',
  ContentHomeNewStatic = 'ContentHomeNewStatic',
  ContentHomeHelp = 'ContentHomeHelp',
  ContentHomeHelpSolid = 'ContentHomeHelpSolid',
  ContentHomeTime = 'ContentHomeTime',
  ContentHomeCoupon = 'ContentHomeCoupon',
  ContentHomeRightArrow = 'ContentHomeRightArrow',
  ContentHomeScroll = 'ContentHomeScroll',
  ContentHomeLowRank = 'ContentHomeLowRank',
  ContentHomeMark = 'ContentHomeMark',
  ContentHomeMarkPc = 'ContentHomeMarkPc',
  ContentHome0Hour = 'ContentHome0Hour',
  ContentHome1Hour = 'ContentHome1Hour',
  ContentHome2Hour = 'ContentHome2Hour',
  ContentHome3Hour = 'ContentHome3Hour',
  ContentHome0HourStatic = 'ContentHome0HourStatic',
  ContentHome1HourStatic = 'ContentHome1HourStatic',
  ContentHome2HourStatic = 'ContentHome2HourStatic',
  ContentHome3HourStatic = 'ContentHome3HourStatic',
  ContentHomeComment = 'ContentHomeComment',
  ContentHomeMoreLine = 'ContentHomeMoreLine',
  ContentHomeListDivider = 'ContentHomeListDivider',
  ContentHomeDivider = 'ContentHomeDivider',
  ContentHomeDot = 'ContentHomeDot',
  ContentHomeTimeStatic = 'ContentHomeTimeStatic',
  ContentHomeTime2Static = 'ContentHomeTime2Static',
  ContentHome15Static = 'ContentHome15Static',
  ContentHome19Static = 'ContentHome19Static',
  ContentHome19SelfStatic = 'ContentHome19SelfStatic',
  ContentHomeArrowSolid = 'ContentHomeArrowSolid',
  ContentHomeArrow02Solid = 'ContentHomeArrow02Solid',
  ContentHomeArrowSolidStatic = 'ContentHomeArrowSolidStatic',
  ContentHomePlayStatic = 'ContentHomePlayStatic',
  ContentHomeFilter = 'ContentHomeFilter',
  ContentHomeArrowDown = 'ContentHomeArrowDown',
  ContentHomeCheckOn = 'ContentHomeCheckOn',
  ContentHomeCheckOff = 'ContentHomeCheckOff',
  ContentHomeAnchorStatic = 'ContentHomeAnchorStatic',
  ContentHomeSaleset = 'ContentHomeSaleset',
  ViewerGuideArrowLeftStatic = 'ViewerGuideArrowLeftStatic',
  ViewerGuideArrowRightStatic = 'ViewerGuideArrowRightStatic',
  ViewerGuideArrowDownStatic = 'ViewerGuideArrowDownStatic',
  ViewerGuideTouchStatic = 'ViewerGuideTouchStatic',
  ViewerSoundStatic = 'ViewerSoundStatic',
  ViewerMuteStatic = 'ViewerMuteStatic',
  ViewerThemeWhiteOffStatic = 'ViewerThemeWhiteOffStatic',
  ViewerThemeWhiteOnStatic = 'ViewerThemeWhiteOnStatic',
  ViewerThemeLightGrayOnStatic = 'ViewerThemeLightGrayOnStatic',
  ViewerThemeLightGrayOffStatic = 'ViewerThemeLightGrayOffStatic',
  ViewerThemeDarkGrayOffStatic = 'ViewerThemeDarkGrayOffStatic',
  ViewerThemeDarkGrayOnStatic = 'ViewerThemeDarkGrayOnStatic',
  ViewerThemeBlackOffStatic = 'ViewerThemeBlackOffStatic',
  ViewerThemeBlackOnStatic = 'ViewerThemeBlackOnStatic',
  ViewerThemeSepiaOffStatic = 'ViewerThemeSepiaOffStatic',
  ViewerThemeSepiaOnStatic = 'ViewerThemeSepiaOnStatic',
  ViewerThemeGreenOffStatic = 'ViewerThemeGreenOffStatic',
  ViewerThemeGreenOnStatic = 'ViewerThemeGreenOnStatic',
  ViewerMarginBlackOffStatic = 'ViewerMarginBlackOffStatic',
  ViewerMarginBlackOnStatic = 'ViewerMarginBlackOnStatic',
  ViewerMarginWhiteOffStatic = 'ViewerMarginWhiteOffStatic',
  ViewerMarginWhiteOnStatic = 'ViewerMarginWhiteOnStatic',
  ViewerBarList = 'ViewerBarList',
  ViewerBarTts = 'ViewerBarTts',
  ViewerBarComment = 'ViewerBarComment',
  ViewerBarArrowLeft = 'ViewerBarArrowLeft',
  ViewerBarArrowRight = 'ViewerBarArrowRight',
  Viewer10sPrev = 'Viewer10sPrev',
  Viewer10sNext = 'Viewer10sNext',
  ViewerSeekbarPrev = 'ViewerSeekbarPrev',
  ViewerEnd = 'ViewerEnd',
  ViewerEndStar = 'ViewerEndStar',
  ViewerEndComment = 'ViewerEndComment',
  ViewerEndCommentOff = 'ViewerEndCommentOff',
  ViewerEndCommentOn = 'ViewerEndCommentOn',
  ViewerNextChapter = 'ViewerNextChapter',
  ViewerSettingBrightness = 'ViewerSettingBrightness',
  ViewerSettingRefresh = 'ViewerSettingRefresh',
  ViewerPlayM = 'ViewerPlayM',
  ViewerPauseM = 'ViewerPauseM',
  ViewerReplyM = 'ViewerReplyM',
  ViewerPlayS = 'ViewerPlayS',
  ViewerCloseS = 'ViewerCloseS',
  ViewerFontGothicOff = 'ViewerFontGothicOff',
  ViewerFontGothicOn = 'ViewerFontGothicOn',
  ViewerFontBatangOff = 'ViewerFontBatangOff',
  ViewerFontBatangOn = 'ViewerFontBatangOn',
  ViewerFontMyungjoOff = 'ViewerFontMyungjoOff',
  ViewerFontMyungjoOn = 'ViewerFontMyungjoOn',
  TabFilter = 'TabFilter',
  TabGiftList = 'TabGiftList',
  TabSorting = 'TabSorting',
  TabCheckOff = 'TabCheckOff',
  TabCheckOn = 'TabCheckOn',
  // 이 아래 아이콘들은 dark모드 아이콘밖에 없고, 디자인팀에서 정의한 네이밍도 뒤에 dark가 붙어있다.
  // 결국 static처럼 사용되는 것 같으므로 static으로 변경요청 해 둔 상태
  ViewerTtsPlaySDark = 'ViewerTtsPlaySDark',
  ViewerTtsPauseSDark = 'ViewerTtsPauseSDark',
  ViewerTtsPrevDark = 'ViewerTtsPrevDark',
  ViewerTtsNextDark = 'ViewerTtsNextDark',
  ViewerSeekbarExpandDark = 'ViewerSeekbarExpandDark',
  ViewerSeekbarReduceDark = 'ViewerSeekbarReduceDark',
  ViewerAudioPlayMDark = 'ViewerAudioPlayMDark',
  ViewerAudioPauseMDark = 'ViewerAudioPauseMDark',
  ViewerAudioCloseMDark = 'ViewerAudioCloseMDark',
  ViewerPlayLDark = 'ViewerPlayLDark',
  ViewerPauseLDark = 'ViewerPauseLDark',
  ViewerReplayLDark = 'ViewerReplayLDark',
  ViewerStarMask = 'ViewerStarMask',
  ViewerStarHalf = 'ViewerStarHalf',
  ViewerStarOff = 'ViewerStarOff',
  ViewerStarOn = 'ViewerStarOn',
  ViewerTop = 'ViewerTop',
  ViewerStart = 'ViewerStart',
  ViewerArrowLeft = 'ViewerArrowLeft',
  ViewerArrowRight = 'ViewerArrowRight',
  ViewerReplayDark = 'ViewerReplayDark',
  Viewer10sNextStatic = 'Viewer10sNextStatic',
  Viewer10sPrevStatic = 'Viewer10sPrevStatic',
  ViewerPauseStatic = 'ViewerPauseStatic',
  ViewerPlayStatic = 'ViewerPlayStatic',
  ViewerReplayStatic = 'ViewerReplayStatic',
  ViewerReplayPcStatic = 'ViewerReplayPcStatic',
  ViewerSeekbarExpandStatic = 'ViewerSeekbarExpandStatic',
  MoreNoticeSolidRedStatic = 'MoreNoticeSolidRedStatic',
  CommentEmojiOffStatic = 'CommentEmojiOffStatic',
  CommentEmojiOnStatic = 'CommentEmojiOnStatic',
  CommentUploadStatic = 'CommentUploadStatic',
  TabArrowDown = 'TabArrowDown',
  TabArrowUp = 'TabArrowUp',

  NavigationAlarmOn = 'NavigationAlarmOn',
  NavigationAlarmOnStatic = 'NavigationAlarmOnStatic',
  NavigationAlarmOff = 'NavigationAlarmOff',
  NavigationBookmarkOnStatic = 'NavigationBookmarkOnStatic',
  NavigationBookmarkOff = 'NavigationBookmarkOff',
  NavigationHeartOnStatic = 'NavigationHeartOnStatic',
  NavigationCashFriendsStatic = 'NavigationCashFriendsStatic',
  NavigationHeartOffStatic = 'NavigationHeartOffStatic',
  NavigationAlarmOffStatic = 'NavigationAlarmOffStatic',
  NavigationBackStatic = 'NavigationBackStatic',
  NavigationSearchStatic = 'NavigationSearchStatic',
  NavigationMenuStatic = 'NavigationMenuStatic',
  NavigationMoreStatic = 'NavigationMoreStatic',
  NavigationHeartOff = 'NavigationHeartOff',
  NavigationBack = 'NavigationBack',
  NavigationClose = 'NavigationClose',
  NavigationCloseStatic = 'NavigationCloseStatic',
  NavigationSearch = 'NavigationSearch',
  NavigationMenu = 'NavigationMenu',
  NavigationMore = 'NavigationMore',
  NavigationContentsHome = 'NavigationContentsHome',
  NavigationSetting = 'NavigationSetting',
  NavigationSettingEpub = 'NavigationSettingEpub',
  NavigationGift = 'NavigationGift',
  NavigationMy = 'NavigationMy',
  NavigationHomeStatic = 'NavigationHomeStatic',
  NavigationHome = 'NavigationHome',
  NavigationCabinet = 'NavigationCabinet',
  NavigationCabinetWeb = 'NavigationCabinetWeb',
  NavigationPage = 'NavigationPage',
  NavigationScroll = 'NavigationScroll',
  NavigationStageMwStatic = 'NavigationStageMwStatic',
  NavigationStagePcStatic = 'NavigationStagePcStatic',
  NavigationArrowLeft = 'NavigationArrowLeft',
  NavigationArrowRight = 'NavigationArrowRight',

  BadgeFreeStatic = 'BadgeFreeStatic',
  Badge0HourStatic = 'Badge0HourStatic',
  Badge1HourStatic = 'Badge1HourStatic',
  Badge2HourStatic = 'Badge2HourStatic',
  Badge3HourStatic = 'Badge3HourStatic',
  BadgeNewStatic = 'BadgeNewStatic',
  BadgeUpStatic = 'BadgeUpStatic',
  Badge15Static = 'Badge15Static',
  Badge19Static = 'Badge19Static',
  BadgeAdultStatic = 'BadgeAdultStatic',
  BadgeEventStatic = 'BadgeEventStatic',
  BadgeTimeStatic = 'BadgeTimeStatic',
  BadgeFree = 'BadgeFree',
  BadgeNew = 'BadgeNew',
  BadgeUp = 'BadgeUp',
  BadgeLock = 'BadgeLock',
  BadgeUnlock = 'BadgeUnlock',
  Badge19SelfStatic = 'Badge19SelfStatic',
  BadgeNovelStatic = 'BadgeNovelStatic',

  ListArrowDownStatic = 'ListArrowDownStatic',
  ListArrowUpStatic = 'ListArrowUpStatic',
  ListArrowRight = 'ListArrowRight',
  ListArrowDown = 'ListArrowDown',
  ListArrowUp = 'ListArrowUp',
  ListBannerSlashStatic = 'ListBannerSlashStatic',

  MenuCashPassVip = 'MenuCashPassVip',
  MenuCash = 'MenuCash',
  MenuCoupon = 'MenuCoupon',
  MenuComment = 'MenuComment',
  MenuCouponRegister = 'MenuCouponRegister',
  MenuSetting = 'MenuSetting',
  MenuCustomer = 'MenuCustomer',
  MenuNotice = 'MenuNotice',
  MenuAlarm = 'MenuAlarm',
  MenuColorMode = 'MenuColorMode',
  ReverseMain = 'ReverseMain',
  /**
   * 톡뷰어 전용
   */
  DefaultProfile = 'DefaultProfile',
  BtnReplayBottom = 'BtnReplayBottom',
  BtnReplayLeft = 'BtnReplayLeft',
  BtnReplayRight = 'BtnReplayRight',
  BtnFullscreenVideoClose = 'BtnFullscreenVideoClose',
  SoundOn = 'SoundOn',
  SoundOff = 'SoundOff',
  BtnVideoPlay = 'BtnVideoPlay',
  StopCount = 'StopCount',
  PlayCount = 'PlayCount',
  KatalknovelAfter = 'KatalknovelAfter',
  KatalknovelBefore = 'KatalknovelBefore',
  BtnFullscreenVideoPlay = 'BtnFullscreenVideoPlay',
  BtnFullscreenVideoPause = 'BtnFullscreenVideoPause',
  BtnKatalkSearch = 'BtnKatalkSearch',
  BtnKatalkMenu = 'BtnKatalkMenu',
  HelixHelpButtonStatic = 'HelixHelpButtonStatic',

  InputboxDelete = 'InputboxDelete',
  InputboxShowOn = 'InputboxShowOn',
  InputboxShowOff = 'InputboxShowOff',

  NavigationComment = 'NavigationComment',
  NavigationContentsHomeStatic = 'NavigationContentsHomeStatic',
  NavigationGiftWeb = 'NavigationGiftWeb',
  NavigationGiftWebDark = 'NavigationGiftWebDark',
  NavigationHeartOn = 'NavigationHeartOn',
  NavigationHeartOnDark = 'NavigationHeartOnDark',
  NavigationHomeMw = 'NavigationHomeMw',
  NavigationHomeMwDark = 'NavigationHomeMwDark',
  NavigationHomeMwStatic = 'NavigationHomeMwStatic',
  NavigationMyWeb = 'NavigationMyWeb',
  NavigationMyWebDark = 'NavigationMyWebDark',
  NavigationPagePc = 'NavigationPagePc',
  NavigationPagePcDark = 'NavigationPagePcDark',
  NavigationRunmodeOff = 'NavigationRunmodeOff',
  NavigationRunmodeOffDark = 'NavigationRunmodeOffDark',
  NavigationRunmodeOnStatic = 'NavigationRunmodeOnStatic',
  NavigationScrollPc = 'NavigationScrollPc',
  NavigationScrollPcDark = 'NavigationScrollPcDark',
  NavigationSoundOffStatic = 'NavigationSoundOffStatic',
  NavigationSoundOnStatic = 'NavigationSoundOnStatic',
  SearchButtonPc = 'SearchButtonPc',
  SearchButtonPcDark = 'SearchButtonPcDark',
  ViewerScene = 'ViewerScene',
  ViewerSceneDark = 'ViewerSceneDark',
  FilterSorting = 'FilterSorting',
}
